import { DEFAULT_MAX_MONTHS } from '../../ui-kit/Calculator/calculatorConstants.js';
import { checkRangeByKeys } from '../../ui-kit/Calculator/rangeHelpers.js';
import { checkRefinancingSourceBookRowCommonParams } from './checkRefinancingSourceBookRowCommonParams.js';
const DEFAULT_MIN_SUM = 10000;
const DEFAULT_REFINANCING_MIN_MONTHS = 13;
const REFINANCING_DEFAULT_MAX_SUM = 3000000;
const REFINANCING_OLD_MIN_SUM = 0;
const REFINANCING_OLD_MAX_SUM = 2500000;
const REFINANCING_EXTRA_MIN_SUM = 0;
const REFINANCING_EXTRA_MAX_SUM = 500000;
export const DEFAULT_REFINANCING_CALCULATOR_PARAMS = {
    minSum: DEFAULT_MIN_SUM,
    maxSum: REFINANCING_DEFAULT_MAX_SUM,
    minSumOld: REFINANCING_OLD_MIN_SUM,
    maxSumOld: REFINANCING_OLD_MAX_SUM,
    minSumExtra: REFINANCING_EXTRA_MIN_SUM,
    maxSumExtra: REFINANCING_EXTRA_MAX_SUM,
    minMonths: DEFAULT_REFINANCING_MIN_MONTHS,
    maxMonths: DEFAULT_MAX_MONTHS,
    rate: 0,
    isExtraMoney: false,
    isSalaryClient: false,
    isInsurance: true,
};
export const getRefinancingCalculatorRateParams = ({ rateRows = [], userInputParams, paramsViewSettings, moneyValue, monthsValue, oldMonthlyPayment, moneyExtra, }) => rateRows?.find((row) => checkRefinancingSourceBookRowCommonParams({
    row,
    userInputParams,
    paramsViewSettings,
}) &&
    checkRangeByKeys(moneyValue + moneyExtra, ['minSum', 'maxSum'], row) &&
    checkRangeByKeys(oldMonthlyPayment, ['minSumOld', 'maxSumOld'], row) &&
    checkRangeByKeys(moneyExtra, ['minSumExtra', 'maxSumExtra'], row) &&
    checkRangeByKeys(monthsValue, ['minMonths', 'maxMonths'], row)) || DEFAULT_REFINANCING_CALCULATOR_PARAMS;
//# sourceMappingURL=getRefinancingCalculatorRateParams.js.map